/**
 * @author alteredq / http://alteredqualia.com/
 *
 * Full-screen textured quad shader
 */



var InvertShader = {

    uniforms: {
        "tDiffuse": { value: null },
        "u_resolution": { value: new THREE.Vector2(0.0, 0.0) },
        "invert_progress": { value: 0. },
    },

    vertexShader:
    `
        varying vec2 vUv;
        void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
        }
    `,

    fragmentShader:
    `
        uniform vec2 u_resolution;
        uniform sampler2D tDiffuse;
        varying vec2 vUv;
        uniform float invert_progress;
        uniform float invert_y;
        

        float when_eq(float x, float y) {
            return 1.0 - abs(sign(x - y));
        }
        
        void main() {
            vec2 normalizedCoord = gl_FragCoord.xy/u_resolution.xy;
            vec4 texel = texture2D( tDiffuse, vUv );
            
            float isInvert = when_eq(step(1. - invert_progress,normalizedCoord.x), .0);
            vec4 a = ((1.0 - texel) * isInvert);
            vec4 b = (texel * (1.-isInvert));
            
            gl_FragColor = vec4( 1.- (a + b) );
        }
    `

};

export default InvertShader;